<template>
    <section class="stores">
        <div class="container stores__wrapper">
            <h1 data-aos="fade-up" data-aos-duration="2000" data-aos-delay="50" class="section__title">Magazine participante</h1>
            <h6 data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100" class="teaser__text">
                Lista magazinelor participante
            </h6>
            <div class="stores__cards">
                <!-- logo 1 -->
                <div data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100" class="stores__card">
                    <a href="" class="stores__link">
                        <img class="stores__logo" src="images/logos/logo-Cora.png" alt="Pufina - Distractie in familie - magazin partener Cora">
                    </a>
                </div>
                <!-- logo 2 -->
                <div data-aos="fade-up" data-aos-duration="2000" data-aos-delay="150" class="stores__card">
                    <a href="" class="stores__link">
                        <img class="stores__logo" src="images/logos/logo-Mega.png" alt="Pufina - Distractie in familie - magazin partener Mega Image">
                    </a>
                </div>
                <!-- logo 3 -->
                <div data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200" class="stores__card">
                    <a href="" class="stores__link">
                        <img class="stores__logo" src="images/logos/logo-Kaufland.png" alt="Pufina - Distractie in familie - magazin partener Kaufland">
                    </a>
                </div>
                <!-- logo 4 -->
                <div data-aos="fade-up" data-aos-duration="2000" data-aos-delay="250" class="stores__card">
                    <a href="" class="stores__link">
                        <img class="stores__logo" src="images/logos/logo-Lidl.png" alt="Pufina - Distractie in familie - magazin partener Lidl">
                    </a>
                </div>
                <!-- logo 5 -->
                <div data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300" class="stores__card">
                    <a href="" class="stores__link">
                        <img class="stores__logo" src="images/logos/carrefour.png" alt="Pufina - Distractie in familie - magazin partener Carrefour">
                    </a>
                </div>
                <!-- logo 6 -->
                <div data-aos="fade-up" data-aos-duration="2000" data-aos-delay="350" class="stores__card stores__card--wide">
                    <a href="" class="stores__link">
                        <img class="stores__logo" src="images/logos/logo-auchan.png" alt="Pufina - Distractie in familie - magazin partener Auchan">
                    </a>
                </div>
                <!-- logo 7 -->
                <div data-aos="fade-up" data-aos-duration="2000" data-aos-delay="400" class="stores__card stores__card--wide">
                    <a href="" class="stores__link">
                        <img class="stores__logo" src="images/logos/profi.png" alt="Pufina - Distractie in familie - magazin partener Profi">
                    </a>
                </div>
                <!-- logo 8 -->
                <div data-aos="fade-up" data-aos-duration="2000" data-aos-delay="450" class="stores__card stores__card--wide">
                    <a href="" class="stores__link">
                        <img class="stores__logo" src="images/logos/alte-magazine.png" alt="Pufina - Distractie in familie - magazine din apopierea ta">
                    </a>
                </div>
            </div>
            <div class="stores__shapes">
                <img data-aos="fade-right" data-aos-duration="2000" data-aos-delay="500" class="stores__shapes--dots" src="images/bg/triangle-dots.png" alt="">
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>